import React from 'react';
import { PlansList } from '@/components/subscription/PlansList';
import { Button } from '@/components/ui/button';

interface SubscriptionPlansModalProps {
    close: () => void;
    description?: string;
    closeLabel?: string;
}

export const SubscriptionPlansModal: React.FC<SubscriptionPlansModalProps> = ({
    close,
    description = 'Sua assinatura atual não permite esta ação ou expirou. Escolha um dos planos abaixo para continuar aproveitando todos os recursos.',
    closeLabel = 'Talvez mais tarde',
}) => {
    return (
        <div className="space-y-6">
            <div className="space-y-2 text-center">
                <p className="text-muted-foreground">{description}</p>
            </div>

            <PlansList compact />

            <div className="flex justify-end pt-2">
                <Button variant="ghost" onClick={close}>
                    {closeLabel}
                </Button>
            </div>
        </div>
    );
};
